import { useEffect } from 'react';
import { useUser } from '@/hooks/user/useUser';
import { useFrontendConfigs } from '@/hooks/useFrontendConfigs';
import { identifyGroundcoverUserInBrowser } from '@/lib/frontendConfigs';

/**
 * Re-identify Groundcover when the RTK user (uid/sub) updates. Lives under `LoadThirdPartyConfigs`
 * with the rest of third-party setup, not in `AppRoutes`.
 */
export const GroundcoverIdentifyEffect = () => {
    const { configs } = useFrontendConfigs();
    const { user } = useUser();

    useEffect(() => {
        identifyGroundcoverUserInBrowser(configs, user);
    // Re-run when id fields change, not only on `user` object identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configs, user?.uid, user?.sub]);

    return null;
};
